export default __webpack_public_path__ + "static/media/hosting.0dec4044.svg";